export const ROOT = '/'

// RSVP Paths
export const MAGIC_LINK_AUTH = `${ROOT}magic-link-auth`
export const RSVP_ROUTE = `/rsvp`

// Landing paths
export const HOME = ROOT
export const ABOUT_US = `${ROOT}about-us`
export const MEMBERSHIPS = `${ROOT}memberships`
export const MEMBERSHIPS_INDIVIDUAL = `${MEMBERSHIPS}/individual`
export const MEMBERSHIPS_CORPORATE = `${MEMBERSHIPS}/corporate`
export const CLUBHOUSE = `${ROOT}clubhouse`
export const SUBMIT_SCORECARD = `${ROOT}submit-scorecard`
export const TERMS_CONDITIONS = `${ROOT}terms-conditions`
export const PRIVACY_POLICY = `${ROOT}privacy-policy`
export const EVENTS = `${ROOT}events`
export const EVENT_DETAILS = (id?: string) => `${EVENTS}/${id || ':id'}`
export const EVENT_RSVP = (id?: string) => `${EVENT_DETAILS(id)}${RSVP_ROUTE}`
export const BLOG = `${ROOT}blog`
export const BLOG_POST = (id?: string) => `${BLOG}/${id || ':id'}`

export const EXECUTIVE_INVITE = `${ROOT}executive-invite`

// Paths for development
export const TEST = `${ROOT}test/`
export const UI_KIT = `${TEST}ui-kit`

// Path for redirect to MEMBERSHIPS
// this is a non-removable path from Google Ads
export const GOLF_COMPETITION = `${ROOT}golf/competition`
